var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinWithdrawalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2879_6013)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 26,
    rx: 8,
    fill: "#D2A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0908 19.5L7.909 19.5L21.0908 19.5ZM7.909 6.5L21.0908 6.5L7.909 6.5Z",
    fill: "#06FF3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3994 8.75C21.2798 8.75 21.8909 9.14978 22.2326 9.94935C22.5757 10.7476 22.4374 11.4565 21.8179 12.0761L16.7309 17.163C16.5352 17.3587 16.3233 17.5054 16.095 17.6033C15.8668 17.7011 15.6222 17.75 15.3613 17.75C15.1005 17.75 14.8559 17.7011 14.6276 17.6033C14.3994 17.5054 14.1874 17.3587 13.9918 17.163L8.90482 12.0761C8.28525 11.4565 8.14699 10.7476 8.49003 9.94935C8.83177 9.14978 9.44286 8.75 10.3233 8.75L20.3994 8.75Z",
    fill: "#FF0606"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2879_6013",
    x: -41.3744,
    y: -41.3744,
    width: 111.749,
    height: 108.749,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 20.6872
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2879_6013"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2879_6013",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinWithdrawalIcon);
export default __webpack_public_path__ + "static/media/fin_withdrawal_icon.941495a1cf299372a0104652231a2cac.svg";
export { ForwardRef as ReactComponent };